(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["build-a-bundle"] && !Shopify.designMode) return;
  try {
    function initBundleTabs(root) {
    if (!root) return;
    if (root.dataset.bundleTabsInitialized === 'true') return;
    root.dataset.bundleTabsInitialized = 'true';

    const tablist = root.querySelector('.bundle-collections .tabs-nav[role="tablist"]');
    const tabs = tablist ? Array.from(tablist.querySelectorAll('[role="tab"]')) : [];
    const panels = Array.from(root.querySelectorAll('.bundle-collections [role="tabpanel"]'));

    if (!tablist || tabs.length === 0 || panels.length === 0) return;

    function setActive(index, options) {
      const shouldFocus = Boolean(options && options.focus);
      const tab = tabs[index];
      const panel = panels[index];
      if (!tab || !panel) return;

      tabs.forEach((t, i) => {
        const isActive = i === index;
        t.setAttribute('aria-selected', isActive ? 'true' : 'false');
        t.tabIndex = isActive ? 0 : -1;
        const li = t.closest('li');
        if (li) li.classList.toggle('active', isActive);
      });

      panels.forEach((p, i) => {
        const isActive = i === index;
        p.hidden = !isActive;
        p.classList.toggle('active', isActive);
      });

      if (shouldFocus) tab.focus();
    }

    const initialIndex = Math.max(
      0,
      tabs.findIndex((t) => t.getAttribute('aria-selected') === 'true')
    );
    setActive(initialIndex);

    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => setActive(index, { focus: true }));
      tab.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          setActive(index, { focus: true });
        }
      });
    });

    tablist.addEventListener('keydown', (e) => {
      const currentIndex = tabs.findIndex((t) => t === document.activeElement);
      if (currentIndex === -1) return;

      let nextIndex = currentIndex;
      if (e.key === 'ArrowRight') nextIndex = (currentIndex + 1) % tabs.length;
      if (e.key === 'ArrowLeft') nextIndex = (currentIndex - 1 + tabs.length) % tabs.length;
      if (e.key === 'Home') nextIndex = 0;
      if (e.key === 'End') nextIndex = tabs.length - 1;

      if (nextIndex !== currentIndex) {
        e.preventDefault();
        setActive(nextIndex, { focus: true });
      }
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.build-bundle').forEach((el) => initBundleTabs(el));
  });
  } catch(e) { console.error(e); }
})();

})();
